import { RoundingMode } from 'bi-fraction';
import React from 'react';

import MobileSupportTooltip from '../MobileSupportTooltip';
import type { NumProps } from './Num';
import { Num } from './Num';

const PreciseNum = (props: NumProps) => {
  return (
    <MobileSupportTooltip
      content={
        <Num
          roundingMode={RoundingMode.ROUND_DOWN}
          {...props}
          decimalPlaces={18}
          showSignificantDecimalsForSmallValues={false}
        />
      }
    >
      <Num
        foldDecimals={true}
        roundingMode={RoundingMode.ROUND_DOWN}
        {...props}
      />
    </MobileSupportTooltip>
  );
};

export default PreciseNum;
